import { Component, OnInit, Input, EventEmitter, Output, HostListener,AfterViewInit, Inject } from '@angular/core';

import { LookupsService, UserService, ResponseStatus, SystemConfigurationService, WeekDaysEnum, WorkingHoursHelper, Helper } from '@linkdev/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentsService } from '@linkdev/document-manage-library';
import { LocationService } from '@linkdev/config-management-library';
import { ServiceManagementRoutes, SERVICE_MANAGEMENT_CONFIG, ServiceManagementConfig, ServiceManageService } from '@linkdev/service-management-library';
import { ServiceTypeEnum } from '../models/serviceTypeEnum';
import { ServiceDefinitionAvailabilitySlotViewModel } from '../models/serviceDefinitionAvailabilitySlotViewModel';
import { serviceDefinitionDetailsModel } from '../models/serviceDefinitionDetailsModel';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { UIHTMLContainerViewModel } from '../models/UIHTMLContainerViewModel';
import { HttpResponse } from '@angular/common/http';
import { CommonService } from '@linkdev/ssa-shared';
import { RatingServiceSubmition } from '../service-list/models/rating-service-submition';
@Component({
  selector: 'app-service-details',
  templateUrl: './service-details.component.html',
})
export class ServiceDetailsComponent implements OnInit, AfterViewInit {

  model: serviceDefinitionDetailsModel = new serviceDefinitionDetailsModel();
  ServiceChannelTypeList = [];
  ServiceCategory = [];
  ServiceSubCategory = [];
  userSegment = []
  ServiceLocations = [];
  paymentMethodList = [];

  translationData: any;
  currencyTrans: any;
  currentUser: any
  hasProfile: boolean;
  identityUser: any;
  @Input() baseURL: string;
  baseuRL:string;
  currentURL:string;
  descriptionAttachments = 'description';
  termsConditionsAttachments = 'termsConditions';
  policiesAttachments = 'policies';
  requiredDocumentsAttachments = 'requiredDocuments';
  feesAttachments = 'fees';
  prerequisitesAttachments = 'prerequisites';
  templatesAttachments = 'templates';
  ratingStarId:number;
  ratingStarHover:number;
  descriptionAttachmentsData: any[];
  termsConditionsAttachmentsData: any[];
  policiesAttachmentsData: any[];
  requiredDocumentsAttachmentsData: any[];
  feesAttachmentsData: any[];
  prerequisitesAttachmentsData: any[];
  templatesAttachmentsData: any[];
  isStatic: boolean;
  isAutomated: boolean;

  breadCrumbServiceName: string
  serviceLoaded: boolean;

  defaultCurrencyConfigKey: string = "defaultCurrency";
  defaultCurrencyValue: string;

  hasInquiryAppointment: boolean = false;

  serviceManagementRoutesBaseRoute: string = ServiceManagementRoutes.baseRoute;
  serviceCardsRoute: string = `#/${this.serviceManagementRoutesBaseRoute}/${ServiceManagementRoutes.serviceCardsRoute}`;

  serviceListRouteName: string = ServiceManagementRoutes.serviceCardsRoute;
  totalNumber: any;
;
  availableDaysList: any[] = [];
  serviceDetailsRoute: string = `#/${this.serviceManagementRoutesBaseRoute}/${ServiceManagementRoutes.serviceDetailsRoute}`;

  configuredTimeZoneStringValue: string = '';
  @ViewChild('tabscontent')
  tabsContent: ElementRef 
  @ViewChild(SwiperDirective, { static: false }) directiveRef?: SwiperDirective;
  swiperConfig: SwiperConfigInterface;    
  swiperClass: any;  
  isMobile: boolean = Helper.isMobile;
  dir: string;     
  isBlanK:boolean;
  innerComponentsData: any = {};
  public containers: UIHTMLContainerViewModel[];
  ratingServiceSubmition = new RatingServiceSubmition;    

  constructor(@Inject(SERVICE_MANAGEMENT_CONFIG) public config: ServiceManagementConfig, public _service: ServiceManageService, private _documentService: DocumentsService, private _userService: UserService, private _router: Router, private activeRoute: ActivatedRoute, private _translate: TranslateService, private lookupService: LookupsService,
    private _systemConfigService: SystemConfigurationService,
    private _locationService: LocationService,
   private _commonService: CommonService) {

    this._systemConfigService.getSystemConfigurationByKeys([this.defaultCurrencyConfigKey, "timeZone"]).subscribe(config => {
      this.defaultCurrencyValue = config.find(config => config.key === this.defaultCurrencyConfigKey)?.value;
      WorkingHoursHelper.configuredTimeZone = +(config.find(config => config.key === "timeZone")?.value || 0);
      this.configuredTimeZoneStringValue = WorkingHoursHelper.getConfiguredTimeZoneStringValue();
    })
  }
  extractBaseURL(): void {
    const indexOfHash = this.currentURL.indexOf('/#');
    if (indexOfHash !== -1) {
      this.baseuRL = this.currentURL.substring(0, indexOfHash);
    } else {
      this.baseuRL = this.currentURL;
    }
  }
  ngOnInit(): void {
    this.currentURL = window.location.href
    this.extractBaseURL();
    window.scroll(0, 0);
    this._translate.get(["serviceManagement", "currency"]).subscribe((data) => {
      this.translationData = data.serviceManagement;
      this.currencyTrans = data.currency;
    });

    this._userService.getCurrentUser().subscribe((user) => {
      if (user) {
        this.identityUser = user
          this.ratingServiceSubmition.email = user.profile.email;
        this._service.getProfileSummary(user.profile.sub).subscribe(res => {
          this.hasProfile = res.status == ResponseStatus.Success ? true : false;
          //this.currentUser = res.data
          this._service._impersonationService.currentUser = this.identityUser
          this.loadServiceDetails()
        })
      }
      else {
        this.loadServiceDetails()
      }
    })
    
    this.lookupService.getLookups(["ServiceChannelType", "ServiceCategory", "ServiceSubCategory", "PaymentMethod"]).subscribe(res => {
      this.ServiceChannelTypeList = res[0].lookupItems;
      this.ServiceCategory = res[1].lookupItems;
      this.ServiceSubCategory = res[2].lookupItems;
      this.paymentMethodList = res[3].lookupItems;
    });

    this._locationService.getLocationsLookup(true, true, false, false).subscribe(locations => {
      this.ServiceLocations = locations;
    })

    this._service.getProfileTypes().subscribe(res => {
      this.userSegment = res;
    });
    

    this.swiperConfiguration();
  }

  handleServiceAvaiability() {
    if (!this.model?.hasCustomApplicantSubmissionFrequency && !this.model?.hasCustomDaysAvailability) {
      return;
    }

    this.setDaysAvailbility();
    if (!WorkingHoursHelper.configuredTimeZone) {
      this._systemConfigService.getSystemConfigurationByKey("timeZone").subscribe(timeZone => {
        WorkingHoursHelper.configuredTimeZone = +(timeZone?.value || 0);
        this.configuredTimeZoneStringValue = WorkingHoursHelper.getConfiguredTimeZoneStringValue();
        this.updateServiceAvailabilityGridContent();
      });
    }
    else {
      this.configuredTimeZoneStringValue = WorkingHoursHelper.getConfiguredTimeZoneStringValue();
      this.updateServiceAvailabilityGridContent();
    }

    let startDate = new Date(this.model.availabilityStartDate);
    let endDate = new Date(this.model.availabilityEndDate);

    this.model.availabilityStartDateCalendar = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()}`;
    this.model.availabilityEndDateCalendar = `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()}`;
  }

  setDaysAvailbility() {
    this.availableDaysList.push({ id: WeekDaysEnum.Sunday, displayName: this.translationData?.sunday || 'Sunday' });
    this.availableDaysList.push({ id: WeekDaysEnum.Monday, displayName: this.translationData?.monday || 'Monday' });
    this.availableDaysList.push({ id: WeekDaysEnum.Tuesday, displayName: this.translationData?.tuesday || 'Tuesday' });
    this.availableDaysList.push({ id: WeekDaysEnum.Wednesday, displayName: this.translationData?.wednesday || 'Wednesday' });
    this.availableDaysList.push({ id: WeekDaysEnum.Thursday, displayName: this.translationData?.thursday || 'Thursday' });
    this.availableDaysList.push({ id: WeekDaysEnum.Friday, displayName: this.translationData?.friday || 'Friday' });
    this.availableDaysList.push({ id: WeekDaysEnum.Saturday, displayName: this.translationData?.saturday || 'Saturday' });
  }


  ngAfterViewInit() {
  }

  handleNavigation = (e) => {
    e.preventDefault();

    if (e.target.closest('li')) {
      let id = e.target.getAttribute('href');
      let targetSection = document.getElementById(id);
      window.scrollTo({ top: targetSection.offsetTop, behavior: 'smooth' });
    }
  };

  getServiceChannelType(id: number) {
    if (id) {
      let serviceChannel = this.ServiceChannelTypeList.find(s => s.id == id)
      if (serviceChannel)
        return serviceChannel.displayName;
    }
  }

  getServiceCategoryName(id: number) {
    if (id) {
      let serviceCategory = this.ServiceCategory.find(s => s.id == id)
      if (serviceCategory)
        return serviceCategory.displayName;
    }
  }

  getServiceSubCategoryName(id: number) {
    if (id) {
      let serviceSubCategory = this.ServiceSubCategory.find(s => s.id == id)
      if (serviceSubCategory)
        return serviceSubCategory.displayName;
    }
  }

  getUserSegmentName(id: number) {
    if (id) {
      let userSegment = this.userSegment.find(s => s.id == id)
      if (userSegment)
        return userSegment.displayName;
    }
  }

  getPaymentMethodName(id: number) {
    if (id) {
      let paymentMethod = this.paymentMethodList.find(s => s.id == id)
      if (paymentMethod)
        return paymentMethod.displayName;
    }
  }

  getTotalServicFees(): number {
    if (this.model && this.model.serviceDefinitionFees?.length > 0) {
      let sum = this.model.serviceDefinitionFees.map(o => o.amount).reduce((sum, curr) => sum + curr, 0);
      return sum;
    }
    return 0;
  }

  getServiceLocationName(id: number): number {
    if (id) {
      let serviceLocation = this.ServiceLocations.find(s => s.id == id)
      if (serviceLocation)
        return serviceLocation.displayName;
    }
  }

  onApplyClick() {
    if (!this.model.isEligibleToApply) {
      document.getElementById("applyTooltip").click();
      return;
    }
    if(!this.isServiceAllowAnonymous())
    {
    this._userService.isLoggedIn().subscribe((loggedIn) => {
      if (!loggedIn) {
        this._userService.login(true).subscribe(() => {
        });
      }
      else {

        this._userService.getCurrentUser().subscribe((user) =>{
          if (user.profile.isExternalUser === true && user.profile.email.includes("nafathtemp")){
              this._router.navigate([`account/profile`]);
            }
            else{
                this._router.navigate([`${this.serviceManagementRoutesBaseRoute}/${ServiceManagementRoutes.applyRequestRoute}/${this.model.id}`]);
            }
        });
      }
    });
  }
  else
  {
    this._router.navigate([`${this.serviceManagementRoutesBaseRoute}/${ServiceManagementRoutes.applyRequestRoute}/${this.model.id}`]);
  }
  }
    isServiceAllowAnonymous(): boolean {
    let allowAnonymousServices = [3];
    return allowAnonymousServices.includes(this.model.id);
  }

  loadServiceDetails() {
    this.activeRoute.params.subscribe(routedData => {
      this.isBlanK=routedData.isBlank==1?true:false
      this.ratingServiceSubmition.serviceId = routedData.serviceKey;
      this._service.getServicesDetails(routedData.serviceKey).subscribe(result => {
        if (result.status == ResponseStatus.Success) {

          this.model = result.data;
          this.getImgPath(this.model.image)
          this.handleServiceAvaiability();
          document.title = this.model.serviceName + (this.translationData.portalNameForDocumentTitle || "");
          this.isStatic = result.data.serviceTypeId == ServiceTypeEnum.StaticService;
          this.isAutomated = result.data.serviceTypeId == ServiceTypeEnum.AutomatedOnly;

          this.breadCrumbServiceName = this.model.serviceName;

          if (this.model.serviceDefinitionAttachments && this.model.serviceDefinitionAttachments.length > 0)
            this.categorizeAttachments(this.model.serviceDefinitionAttachments);
          else
            this.clearAttachments();

          this.serviceLoaded = false
          setTimeout(() => {
            this.serviceLoaded = true
          }, 1);

        }

        else {
          this._router.navigate(['/'])
        }
      });
    });
  }

  categorizeAttachments(serviceDefinitionAttachments: any[]) {
    this.descriptionAttachmentsData = serviceDefinitionAttachments.filter(s => s.attachedFieldName == this.descriptionAttachments);
    this.termsConditionsAttachmentsData = serviceDefinitionAttachments.filter(s => s.attachedFieldName == this.termsConditionsAttachments);
    this.policiesAttachmentsData = serviceDefinitionAttachments.filter(s => s.attachedFieldName == this.policiesAttachments);
    this.requiredDocumentsAttachmentsData = serviceDefinitionAttachments.filter(s => s.attachedFieldName == this.requiredDocumentsAttachments);
    this.feesAttachmentsData = serviceDefinitionAttachments.filter(s => s.attachedFieldName == this.feesAttachments);
    this.prerequisitesAttachmentsData = serviceDefinitionAttachments.filter(s => s.attachedFieldName == this.prerequisitesAttachments);
    this.templatesAttachmentsData = serviceDefinitionAttachments.filter(s => s.attachedFieldName == this.templatesAttachments);
  }

  clearAttachments() {
    this.descriptionAttachmentsData =
      this.termsConditionsAttachmentsData =
      this.policiesAttachmentsData =
      this.requiredDocumentsAttachmentsData =
      this.feesAttachmentsData =
      this.prerequisitesAttachmentsData =
      this.templatesAttachmentsData = null
  }

  download(documentIdentifier: any, documentName: string) {
    this._documentService.downloadUrlGet(`${this._service.config.baseUrl}/serviceCatalog/download/${documentIdentifier}`, documentName);
  }

  downloadAll(attachments: any[]) {
    for (let index = 0; index < attachments.length; index++) {
      setTimeout(() => {
        this.download(attachments[index].attachmentGuid, attachments[index].fileName);
      }, 1000);
    }
  }

  getApplyButtonTooltip() {
    if (!this.model.isActive) {
      return this.translationData?.inactiveService || "This service is currently unavailable.";
    }
    else if (!this.model.isEligibleProfileType) {
      return this.translationData?.notEligibleProfileTypeToApplyMsg || "Not eligible profile type.";
    }
    else if (!this.model.isValidMultipleRequests) {
      return this.translationData?.notAllowedMultipleRequestsMsg || "You can't apply while you having an active request.";
    }
    else if (!this.model.isPermittedToApply) {
      return this.translationData?.notPermittedToApplyMsg || "You don't have permission to apply.";
    }
    else if (!this.model.isAvailable) {
      return this.translationData?.inAvailableService || "This service is currently unavailable. Please check the available slots.";
    }

    return this.translationData?.applyForRequest || 'Apply for request';
  }

  updateServiceAvailabilityGridContent() {
    if (this.model.serviceDefinitionAvailabilitySlots?.length) {
      for (let [avaliblilityIndex, sa] of this.model.serviceDefinitionAvailabilitySlots.entries()) {
        sa = Object.assign(new ServiceDefinitionAvailabilitySlotViewModel(), sa);

        let today = new Date();

        const startTimeArray = sa.startTime.split(':');
        sa.startTime = WorkingHoursHelper.updateTimeByTimezone(+startTimeArray[0]).toString().padStart(2, '0') + ':' + startTimeArray[1];
        sa.startTimeDisplay = WorkingHoursHelper.convertDateToUTCDate(sa.startTime, this.translationData, 0);

        const endTimeArray = sa.endTime.split(':');
        sa.endTime = WorkingHoursHelper.updateTimeByTimezone(+endTimeArray[0]).toString().padStart(2, '0') + ':' + endTimeArray[1];
        sa.endTimeDisplay = WorkingHoursHelper.convertDateToUTCDate(sa.endTime, this.translationData, 0);

        sa.dayName = this.availableDaysList?.find(x => x.id == sa.day)?.displayName;

        this.model.serviceDefinitionAvailabilitySlots[avaliblilityIndex] = sa;
      }

      this.model.serviceDefinitionAvailabilitySlots?.sort((a, b) => a.dayName !== b.dayName ? a.dayName < b.dayName ? -1 : 1 : 0)
    }
  }

  hasCustomAvaibailitySection() {
    return (this.model?.hasCustomApplicantSubmissionFrequency && (this.model.applicantMaxRequestsDurationInDays || this.model.maxRequestsPerApplicant))
      || (this.model?.hasCustomDaysAvailability && (this.model.availabilityStartDate || this.model.availabilityEndDate || this.model?.serviceDefinitionAvailabilitySlots?.length));
  }
  @HostListener('window:resize', ['$event'])
  onResize(_event) {
    this.isMobile = Helper.checkIsMobile();
    this.swiperConfiguration();
  }
  swiperConfiguration() {
    var defaultSwiperSlidesPerView = this.config.generalConfig?.swiperConfig?.defaultSlidesPerView;
    var defaultSwiperSpaceBetween = this.config.generalConfig?.swiperConfig?.defaultSpaceBetween;
    var defaultSwiperClass = this.config.generalConfig?.swiperConfig?.defaultClass;

    var processCustomSwiperConfig =
      this.config.generalConfig?.swiperConfig?.[this.innerComponentsData?.requestInfo?.serviceDefinition?.processId];

    this.swiperClass = (processCustomSwiperConfig?.class || defaultSwiperClass || 'justify-content-around');

    this.swiperConfig = {
      freeMode: true,
      slidesPerView: this.isMobile ? this.containers?.length : (processCustomSwiperConfig?.slidesPerView || defaultSwiperSlidesPerView || 5),
      spaceBetween: (defaultSwiperSpaceBetween || 6),
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      observer: true,
      breakpoints: {
        992: {
          spaceBetween: this.isMobile ? 0 : (defaultSwiperSpaceBetween || 6),
          slidesPerView: this.isMobile ? this.containers?.length : (processCustomSwiperConfig?.slidesPerView || defaultSwiperSlidesPerView || 3),
        },
      }
    };
  }
  defaultAvatar = "../../assets/images/service-avatar.webp";
  imagesDic: any = {};
  getImgPath(img) {
    if (this.imagesDic[img] || this.imagesDic[img + 'requesting']) {
      return;
    }

    if (img && !this.imagesDic[img]) {
      this.imagesDic[img + 'requesting'] = true;
      this._service.getDocumentContent(img).subscribe(
        (response: HttpResponse<Blob>) => {
            this.imagesDic[img + 'requesting'] = false;
            this.imagesDic[img] = this._documentService.getBlobURL(response.body);
          },
          () => {
            this.imagesDic[img + 'requesting'] = false;
            this.imagesDic[img] = img;
          }
        );
    }
  }

  getImageSrc(img) {
    return this.imagesDic[img] //|| this.defaultAvatar;
  }
  submitRating(){
    this.ratingServiceSubmition.isAfterSubmit= true;
    this.ratingServiceSubmition.serviceRatingId= this.ratingStarId ?  this.ratingStarId : this.ratingStarHover ;
    this._commonService.submitServiceRate(this.ratingServiceSubmition).subscribe(result => {
      if(result){
        this.ratingStarId= null;
        this.ratingStarHover = null;
      }
    });
  }
}
